import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { User } from '../../user'
import { useImpersonate } from '../../hooks'
import { savePreviousTokens, useAuth } from '../../../auth'
import { useNavigate } from '@tanstack/react-router'

export type UserImpersonateButtonProps = {
    user: Pick<User, 'id' | 'blockedAt'>
}
export function UserImpersonateButton({ user }: UserImpersonateButtonProps) {
    const { t } = useTranslation()
    const mutation = useImpersonate()
    const { is, loginFromResponse } = useAuth()
    const navigate = useNavigate()

    return (
        <Button
            onClick={() =>
                mutation.mutateAsync(user.id).then((response) => {
                    savePreviousTokens()

                    navigate({
                        to: '/dashboard',
                    }).then(() => {
                        loginFromResponse(response)
                    })
                })
            }
            disabled={is(user)}
        >
            {t('Impersonate')}
        </Button>
    )
}
